

import axios from "axios";
import { Message } from 'element-ui';

import { Config } from '@/config/config';
// import store from '@/store';

// create an axios instance
const client = axios.create({
    baseURL: Config.url + "/api/v1",
    timeout: 10000,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json"
    },
});

// request interceptor
client.interceptors.request.use(config => {
        // Do something before request is sent
        // if (store.getters.token) {
        // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
        // config.headers['X-Token'] = getToken()
        // }
        return config
    }, error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)


// respone interceptor
client.interceptors.response.use(
    response => response,
    error => {
        console.log('error:' + error) // for debug
        /*Message({
          message: error.message,
          type: 'error',
          duration: 5 * 1000
        })*/
        return Promise.reject(error)
    }
)


export { client };


//////////////////
// WEBPACK FOOTER
// ./src/utils/client.js
// module id = null
// module chunks = 